<div class="container">
  <span class="container__shape breathing-profile">
    <span class="container__shape__item" [ngClass]="bgColorClass"></span>
    <span class="container__shape__item" [ngClass]="bgColorClass"></span>
    <span class="container__shape__item" [ngClass]="bgColorClass"></span>
  </span>
  <ng-content></ng-content>
</div>
